export function initAccordion(selector) {
    const accordions = document.querySelectorAll(selector);
    if (!accordions.length) return;

    accordions.forEach(accordion => {
        const items = accordion.querySelectorAll('.faq__item');

        items.forEach(item => {
            const btn = item.querySelector('.faq__question');
            const content = item.querySelector('.faq__answer');

            btn.addEventListener('click', () => {
                const isActive = item.classList.contains('active');

                // Закриваємо всі
                items.forEach(i => {
                    i.classList.remove('active');
                    const inner = i.querySelector('.faq__answer');
                    inner.style.maxHeight = null;
                    inner.classList.remove('is-open');
                });

                // Відкриваємо потрібний
                if (!isActive) {
                    item.classList.add('active');
                    content.style.maxHeight = content.scrollHeight + "px";
                    content.classList.add('is-open');
                }
            });
        });
    });
}
